module.exports = __webpack_public_path__ + "d05733a2cf3a076daba96fce521ce63e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SS.svg
// module id = ssXP
// module chunks = 0